<template>
  <button :id="professional.id"
          class="btn btn-info"
          ref="btnSelectProfessional"
          @click="setSelectedProfessional(professional)">
    <template v-if="professional.is_favorited_user">
      <i class="fas fa-bolt -status-instant-book -button"></i>
      {{ $t('message.button.instant_book') }}
    </template>
    <template v-else>
      &nbsp;{{ $t('message.button.book') }}&nbsp;
    </template>
  </button>
</template>

<script>
  import { mapGetters } from 'vuex'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'

  export default {
    props: {
      professional: Object
    },
    computed: {
      ...mapGetters({
        preBookingData: 'booking/getPreBookingData',
        selectedProfessional: 'booking/getSelectedProfessional',
        user: 'auth/getUser'
      })
    },
    methods: {
      async setSelectedProfessional (professional) {
        const selectedProfessional = {
          id: professional.id,
          name: professional.name,
          picture: professional.picture,
          jobQty: professional.job_qty,
          active: professional.active,
          province_id: professional.province_id,
          is_excellent: professional.is_excellent,
          professional_services: professional.professional_services,
          latitude: professional.latitude,
          longitude: professional.longitude
        }
        this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', selectedProfessional)
        if (professional.service_cost) {
          this.$store.commit('booking/SET_BOOKING_COST', {totalPrice: professional.service_cost})
        }
        if (!this.preBookingData.province_id) {
          this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', {
            key: 'province_id',
            value: selectedProfessional.province_id
          })
        }

        if (this.user == null || (this.user && Number(this.user.id) === 0)) {
          this.$parent.$parent.$parent.checkLogin()
        } else {
          // Save user event log
          await userEventLogHelpers.logEvent('select_professional', {
            professional_id: selectedProfessional.id
          })
          this.goToCheckoutStep()
        }
      },
      goToCheckoutStep () {
        if (this.user.isPhoneVerified === false) {
          this.$parent.$parent.$parent.$parent.$refs.phoneVerificationModal.openModal()
        } else {
          // Go to checkout
          if (this.selectedProfessional === null) {
            this.$swal(this.$i18n.t('message.alert.select_cleaner'))
          } else {
            // Set booking from in order to back to previous page correctly
            const bookingFrom = {
              from: 'chooseCleaner',
              professionalId: null
            }
            this.$store.commit('booking/SET_BOOKING_FROM', bookingFrom)
            this.$router.push('/booking/checkout')
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/ButtonSelectProfessional.vue